if (!customElements.get('fwd-profile-content')) {
  customElements.define(
    'fwd-profile-content',
    class FwdProfileContent extends HTMLElement {
      connectedCallback() {
        const destination = this.querySelector('[data-fwd-profile-instagram-row]');
        const sources = [...this.querySelectorAll('[data-fwd-profile-instagram-source]')];
        if (!destination || sources.length === 0) return;

        const source = sources.shift();
        const sourceLink = source.closest('a');
        const originalParent = sourceLink?.parentElement || source.parentElement;

        if (sourceLink && sourceLink.textContent.trim() === source.textContent.trim()) {
          destination.append(sourceLink);
        } else if (sourceLink) {
          const relocatedLink = sourceLink.cloneNode(false);
          relocatedLink.append(source);
          destination.append(relocatedLink);
        } else {
          destination.append(source);
        }

        sources.forEach((duplicate) => {
          const duplicateParent = duplicate.parentElement;
          duplicate.remove();
          this.removeEmptySourceContainer(duplicateParent);
        });
        this.removeEmptySourceContainer(originalParent);
        destination.hidden = false;
      }

      removeEmptySourceContainer(element) {
        let candidate = element;
        while (candidate && candidate !== this && !candidate.matches('.main-page-content__section')) {
          if (candidate.textContent.trim() || candidate.querySelector('img, video, iframe')) return;
          const parent = candidate.parentElement;
          candidate.remove();
          candidate = parent;
        }
      }
    }
  );
}
